import { useContext } from 'react';
import { UserLocationContext } from '@honda-canada/user-location';

import BottomElementContext from '../../../Footer/service/BottomElementProvider/BottomElementContext';
import trimPaymentFormatter from '../Payment/utils';
import { useTrimPayment } from '../../../../apiHooks';
import { BAP_PAYMENT_FREQUENCY, BAP_PAYMENT_METHOD } from '../../../ModelCardWithTrims/service/constants';

const useDealerFeeFromPayment = ({
  trim,
  appName,
  showInformationalApr,
  language,
  vehicleType,
  isSellingPriceProvince,
}) => {
  const { provinceCode } = useContext(UserLocationContext) || {};

  const { setPayment, setIsFetching } = useContext(BottomElementContext) || {};

  const paymentOptions = {
    paymentMethod: BAP_PAYMENT_METHOD,
    paymentFrequency: BAP_PAYMENT_FREQUENCY,
  };
  const { payment } = useTrimPayment(
    trim,
    paymentOptions,
    provinceCode,
    data => trimPaymentFormatter(appName, data, paymentOptions, showInformationalApr, language),
    true,
    vehicleType,
    isSellingPriceProvince,
    setPayment,
    setIsFetching,
  );

  const { dealerFee } = payment || {};

  return dealerFee;
};

export default useDealerFeeFromPayment;
